module.exports = __webpack_public_path__ + "static/media/design8.c4db88ae.png";